import React from 'react';
import TestimonialCarousel from './TestimonialCarousel';
import { testimonialData } from '../data';
import { motion as m } from 'framer-motion';
import { fadeIn, staggerContainer } from '../variants';

const Testimonial = () => {
  const { slider, subtitle, title, pretitle, btnText } = testimonialData;
  return <section id='testimonial' className='bg-testimonial bg-cover bg-fixed bg-no-repeat 
  relative h-auto lg:min-h-[110vh] md:pt-[110px]'>
    <div className="absolute top-0 right-0 bottom-0 left-0 bg-black bg-opacity-70" />

    <m.div
    variants={staggerContainer}
    initial='hidden'
    whileInView={'show'}
    viewport={{once: false, amount: 0.2}}
    className='container relative mx-auto pb-10 lg:pb-0 pt-6 z-10 '>
      
      <div className='text-center capitalize flex flex-col items-center'>
        <m.div variants={fadeIn('down', 'tween', 0.3, 1.1)} className='pretitle'>{pretitle}</m.div>
        <m.h2 variants={fadeIn('down', 'tween', 0.4, 1.1)} className='h2 text-white'>{title}</m.h2>
        <m.p variants={fadeIn('down', 'tween', 0.5, 1.1)} className='text-gray-200 mb-4'>{subtitle}</m.p>
      </div>

      <m.div 
      variants={fadeIn('up', 'spring', 0.3, 1.1)} 
      className='flex justify-center items-center'>
        <TestimonialCarousel slider={slider}/>
      </m.div>
      <m.div 
      variants={fadeIn('up', 'tween', 0.3, 1.1)}
      className='flex flex-col items-center mt-3'>
          <a target='_blank' rel="noreferrer" href="https://www.google.com/search?hl=en-LK&gl=lk&q=The+Central+Perk,+9/6+A+16th+Lane,+Marine+Drive,+Colombo+00300&ludocid=8611603576292080223&lsig=AB86z5UUSVNaA9aByTpVy4XDOtyD#lrd=0x3ae25976c5fbf6d1:0x77828fd38f5f7a5f,1"><button className='btn mx-auto lg:mx-0'>{btnText}</button></a>
      </m.div>
    </m.div>
    </section>;
};

export default Testimonial;
